/**
 * TrayBadge - Small badge for displaying counts on tray buttons
 */

import type { ReactNode } from "react"

interface TrayBadgeProps {
    children: ReactNode
}

export function TrayBadge({ children }: TrayBadgeProps) {
    return (
        <span className="ml-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-base-300 px-1 text-[10px] font-medium text-base-content">
            {children}
        </span>
    )
}
